import { useMutation } from '@tanstack/react-query';
import { Send } from 'lucide-react';
import {
  useDataProvider,
  useListContext,
  useNotify,
  useTranslate,
  useUnselectAll,
} from 'ra-core';
import { type AdminDataProvider } from '../../api/adminDataProvider';
import { Spinner } from '../../components/admin/spinner';
import { Button } from '../../components/ui/button';
import { ResourcesValue } from '../resources';
import { type SmsMessage } from './types';

export const SmsMessageResendAction = () => {
  const { selectedIds, refetch } = useListContext<SmsMessage>();
  const dataProvider = useDataProvider<AdminDataProvider>();
  const translate = useTranslate();
  const notify = useNotify();
  const unselectAll = useUnselectAll(ResourcesValue.SMS);

  const resend = useMutation({
    mutationFn: dataProvider.resendWelcomeSms,
    onSuccess: (result) => {
      if (result.failedIds.length === 0) {
        notify('moonstar.sms_message.success', {
          type: 'success',
          messageArgs: { count: result.successfulIds.length },
        });
      } else {
        notify('moonstar.sms_message.partial_success', {
          type: 'warning',
          messageArgs: {
            total_success: result.successfulIds.length,
            total_failed: result.failedIds.length,
          },
        });
      }
    },
    onError: () => {
      notify('moonstar.sms_message.error', {
        type: 'error',
        autoHideDuration: 5000,
      });
    },
    onSettled: () => {
      void refetch();
      unselectAll();
    },
  });

  if (resend.isPending) {
    return <Spinner size="small" />;
  }

  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => resend.mutate({ ids: selectedIds })}
    >
      <Send />
      {translate('moonstar.sms_message.resend')}
    </Button>
  );
};
